export const EXPENSE_CATEGORIES = [
  "بوفيه",
  "كهربا-مياه - غاز-انترنت",
  "ادوات مكتبية",
  "عهد",
  "مستلزمات مخزن",
  "مرسال",
  "مسحوبات",
  "الاقامات",
  "اصول",
  "اجور + مكافأت",
  "صيانة",
  "سلف عاملين",
  "رد",
  "تشغيل",
  "نظافة",
];

export const EntryTypes = {
  AccSession: "AccountingSession",
  Package: "Package",
  AccThHour: "AccountingTherapistHour",
  BalanceEntry: "UserBalance",
  Salary: "Salary",
  Expense: "Expense",
};

export const PAYMENT_METHODS = [
  { value: "Visa", label: "Visa" },
  { value: "Cash", label: "Cash" },
  { value: "Bank-transfer", label: "Bank Transfer" },
];

export const RECEIPT_ENTRY_TYPES = [
  "AccountingSession",
  "Package",
  "UserBalance",
  "Expense",
  "Salary",
];